import { render, staticRenderFns } from "./DynamicGroupCreate.vue?vue&type=template&id=2f65a694&"
import script from "./DynamicGroupCreate.vue?vue&type=script&lang=ts&"
export * from "./DynamicGroupCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports